import React from "react";

const MAP = {
  done: "bg-emerald-500/15 text-emerald-400 border-emerald-500/25",
  completed: "bg-emerald-500/15 text-emerald-400 border-emerald-500/25",
  live: "bg-emerald-500/15 text-emerald-400 border-emerald-500/25",
  published: "bg-emerald-500/15 text-emerald-400 border-emerald-500/25",
  approved: "bg-emerald-500/15 text-emerald-400 border-emerald-500/25",
  in_progress: "bg-amber-500/15 text-amber-400 border-amber-500/25",
  scheduled: "bg-amber-500/15 text-amber-400 border-amber-500/25",
  planned: "bg-sky-500/15 text-sky-400 border-sky-500/25",
  draft: "bg-white/5 text-[#9a9a9a] border-white/10",
  todo: "bg-white/5 text-[#9a9a9a] border-white/10",
  slow_moving: "bg-red-500/15 text-red-400 border-red-500/25",
  best_seller: "bg-[#6B3DFF]/15 brand-text border-[#6B3DFF]/25",
  active: "bg-sky-500/15 text-sky-400 border-sky-500/25",
  high: "bg-red-500/15 text-red-400 border-red-500/25",
  medium: "bg-amber-500/15 text-amber-400 border-amber-500/25",
  low: "bg-white/5 text-[#9a9a9a] border-white/10",
};

export function StatusBadge({ value }) {
  if (!value) return null;
  const cls = MAP[String(value).toLowerCase()] || "bg-white/5 text-[#9a9a9a] border-white/10";
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold capitalize ${cls}`}>
      {String(value).replace(/_/g, " ")}
    </span>
  );
}
